import React from "react"
import { AtribuirFaixasDistanciaContextProvider } from "./context/AtribuirFaixasDistanciaContextProvider"
import { AtribuirFaixasDistancia } from "./AtribuirFaixasDistancia"

export function Index() {
    return (
        <AtribuirFaixasDistanciaContextProvider>
            <AtribuirFaixasDistancia />
        </AtribuirFaixasDistanciaContextProvider>
    )
}
